module.exports = __webpack_public_path__ + "img/battery.9f73d80b.svg";